import styled from 'styled-components';

export const StyledBaseWrapper = styled.div`
  position: relative;
  min-width: 260px;
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
  display: flex;
`;

export const StyledDigitalShelfWrapper = styled(StyledBaseWrapper)`
  // DigitalShelf-specific styles
`;
